var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "98px",
    height: "96px",
    viewBox: "0 0 98 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-255.000000, -91.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.000000, 91.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8544414,0 C63.4985892,7.90725814 73.7401521,14.7539927 79.5791301,20.5402038 C89.437487,30.3094708 97.7088829,42.2222319 97.7088829,56.6837971 C97.7088829,70.0964002 92.6245436,78.2857988 79.5791301,79.8715454 C71.2310629,80.886302 61.4719499,75.8888306 50.301791,64.8791312 C50.2981951,65.2775733 50.2965666,65.6810203 50.2965666,66.088456 C50.2965666,73.92794 50.8994655,83.7493318 52.1052632,95.5526316 L45,95.5526316 C46.1410362,81.8787007 46.7115543,72.0573088 46.7115543,66.088456 L46.7105455,65.9313353 C37.2599579,76.2066555 28.2932703,80.8533922 19.8104826,79.8715454 C6.1102267,78.2857988 -4.26325641e-14,70.5101296 -4.26325641e-14,56.6837971 C-4.26325641e-14,42.03508 9.65590041,30.3743876 19.8104826,20.5402038 C25.6615807,14.8737201 35.3429003,8.02698548 48.8544414,0 Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpade);
export default __webpack_public_path__ + "static/media/Spade.d183b6b8.svg";
export { ForwardRef as ReactComponent };